import Fn from './Modules/Home'

Fn.loadFont()